<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Adicionar operação</h2>
      <FormOperation @submit-requested="submitRequested"></FormOperation>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormOperation from '../forms/FormOperation.vue'

  export default {
  components: { FormOperation },
    methods: {
      ...mapActions('operations', ['addOperation']),
      submitRequested (inputOperation) {
        this.addOperation(inputOperation);
      },
    }
  }
</script> 
 
<style scoped>
</style> 